import { useAutoApprovedQualifications } from "@src/appV2/Licenses/useAutoApprovedQualifications";
import { useNlcStates } from "@src/appV2/Licenses/useNlcStates";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";
import { useRef } from "react";

import { useWorkerQualificationsWithLicenses } from "../useWorkerQualificationsWithLicenses";

export function useRoleDetailsData(qualificationId: string) {
  const { shoppableQualifications } = useDefinedWorker();

  const { openArticle } = useZendeskArticle();
  const { multiStateLicensesSupportLink } = useSupportLinks();

  const { data, isLoading } = useWorkerQualificationsWithLicenses();

  const nlcStates = useNlcStates();
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const autoApprovedQualifications = useAutoApprovedQualifications();

  const role = data.find((item) => item.qualification.id === qualificationId);

  const qualificationLabel = role?.qualification.attributes.displayLabel ?? "";
  const isAutoApproved = autoApprovedQualifications.has(role?.qualification.attributes.name ?? "");

  const isEmpty = !isLoading && role?.licenses.length === 0;

  const shoppableQualification = shoppableQualifications.find(
    (shoppableQualification) =>
      shoppableQualification.relationships.qualification.data.id === qualificationId
  );

  return {
    autoApprovedQualifications,
    isAutoApproved,
    isEmpty,
    isLoading,
    nlcStates,
    qualificationId,
    qualificationLabel,
    role,
    scrollContainerRef,
    shoppableQualificationId: shoppableQualification?.id ?? "",
    onNlcStatesClick: async () => {
      await openArticle(multiStateLicensesSupportLink);
    },
  };
}
